// @ts-nocheck
import styles from "./Canceled.module.scss";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams, useSearchParams } from "react-router-dom";
import useUrlData from "store/DataStore";
import { getOrderData } from "services/api";

type ViewType = 'CANCELED' | 'EXPIRED' | 'NOTFOUND' | 'ERROR';

const Canceled = () => {
  const { t } = useTranslation();
  const { orderId } = useParams<{ orderId: string }>();
  const [searchParams] = useSearchParams();
  const { data: allData, mapServerData, setMockData } = useUrlData();
  const [view, setView] = useState<ViewType>('CANCELED');
  const [loaded, setLoaded] = useState(false);

  const typeFromUrl = searchParams.get('type');

  useEffect(() => {
    if (orderId === 'mock') {
      setMockData({ payment_id: "mock123", amount: 3500, status_name: "canceled" });
      setLoaded(true);
    }
  }, [orderId, setMockData]);

  useEffect(() => {
    if (!orderId || orderId === 'mock') return;
    const fetch = async () => {
      try {
        const data = await getOrderData(orderId);
        mapServerData(data);
      } catch (e) { console.error(e); }
      setLoaded(true);
    };
    fetch();
  }, [orderId, mapServerData]);

  useEffect(() => {
    if (typeFromUrl) {
      if (typeFromUrl === 'expired') setView('EXPIRED');
      else if (typeFromUrl === 'notfound') setView('NOTFOUND');
      else setView('CANCELED');
    } else if (loaded && allData.status_name) {
      const s = allData.status_name.toLowerCase();
      if (s === 'expired') setView('EXPIRED');
      else setView('CANCELED');
    }
  }, [typeFromUrl, loaded, allData.status_name]);

  const getMessage = () => {
    switch (view) {
      case 'EXPIRED':
        return { title: 'Tiempo expirado', desc: 'El tiempo para realizar el pago ha expirado.' };
      case 'NOTFOUND':
        return { title: 'No encontrado', desc: 'No se encontró información sobre este pago.' };
      default:
        return { title: 'Pago cancelado', desc: 'El pago ha sido cancelado.' };
    }
  };

  const { title, desc } = getMessage();
  const formatAmount = (amount: number) => amount?.toLocaleString('es-AR') || '0';

  if (!loaded) {
    return (
      <div className={styles.page}>
        <header className={styles.header}><span className={styles.logo}>PagoPay</span></header>
        <div className={styles.content}>
          <div className={styles.spinner} />
        </div>
      </div>
    );
  }

  return (
    <div className={styles.page}>
      <header className={styles.header}>
        <span className={styles.logo}>PagoPay</span>
        <span className={styles.badge}>{view === 'EXPIRED' ? 'Expirado' : 'Cancelado'}</span>
      </header>

      <div className={styles.content}>
        <div className={styles.icon}>
          {view === 'EXPIRED' ? (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="12" r="10" />
              <path d="M12 6v6l4 2" />
            </svg>
          ) : (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          )}
        </div>
        <div className={styles.title}>{title}</div>
        <div className={styles.subtitle}>{desc}</div>

        {allData.payment_id && (
          <div className={styles.details}>
            <div className={styles.row}>
              <span className={styles.label}>ID</span>
              <span className={styles.value}>{allData.payment_id?.slice(0, 12)}</span>
            </div>
            {allData.amount > 0 && (
              <div className={styles.row}>
                <span className={styles.label}>Monto</span>
                <span className={styles.value}>$ {formatAmount(allData.amount)}</span>
              </div>
            )}
          </div>
        )}

        <div className={styles.info}>
          Puede crear una nueva solicitud de pago en el sitio
        </div>
      </div>

      <footer className={styles.footer}>
        <span>Puede cerrar esta página</span>
      </footer>
    </div>
  );
};

export default Canceled;
